module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-17.669ef4b6.png";